import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

const iconPath = `M42.384,12.76H5.717c-2.025,0-3.667,1.79-3.667,3.998c0,2.208,2.501,15.003,2.772,15.995
c0.287,1.051,0.81,1.984,1.812,1.997v0.002h34.834v0c0.003,0,0.005,0,0.008,0c1.012,0,1.548-0.94,1.833-2c0.284-1.053,
2.742-13.787,2.742-15.995C46.05,14.55,44.409,12.76,42.384,12.76z M9.362,23.76c-2.025,0-3.667-1.642-3.667-3.667
c0-2.025,1.642-3.667,3.667-3.667s3.667,1.641,3.667,3.667C13.029,22.118,11.387,23.76,9.362,23.76z M16.717,31.094
c-2.025,0-3.667-1.642-3.667-3.667c0-2.025,1.642-3.667,3.667-3.667c2.025,0,3.667,1.641,3.667,3.667
C20.383,29.451,18.742,31.094,16.717,31.094z M24.05,23.76c-2.025,0-3.667-1.642-3.667-3.667c0-2.025,1.641-3.667,
3.667-3.667c2.025,0,3.667,1.641,3.667,3.667C27.717,22.118,26.075,23.76,24.05,23.76z M31.383,31.094c-2.025,
0-3.667-1.642-3.667-3.667c0-2.025,1.641-3.667,3.667-3.667c2.025,0,3.667,1.641,3.667,3.667C35.05,29.451,33.408,31.094,
31.383,31.094z M38.717,23.76c-2.025,0-3.667-1.642-3.667-3.667c0-2.025,1.642-3.667,3.667-3.667c2.025,0,3.667,1.641,3.667,
3.667C42.383,22.118,40.742,23.76,38.717,23.76z`

/**
 * Stateless function representing a in-out icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <InOutIcon width={12} />
 */
const InOutIcon = props => (
    <SvgIcon {...props}>
        <path d={iconPath} />
    </SvgIcon>
)

InOutIcon.defaultProps = defaultProps

export { InOutIcon }
